var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    className: "icon--44cab",
    height: "100%",
    y: "0%",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "speaker--99d79",
    "data-role": "speaker",
    d: "M2 9v6a1 1 0 0 0 1 1h5l5 5V3L8 8H3a1 1 0 0 0-1 1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cross--dbe53",
    "data-role": "cross",
    opacity: 1,
    fillRule: "nonzero",
    d: "m18.363 10.955-2.3-2.3-1.061 1.06 2.3 2.301-2.298 2.298 1.06 1.061 2.299-2.298 2.295 2.295 1.061-1.06-2.295-2.296 2.298-2.298-1.061-1.06-2.298 2.297Z",
    style: {
      transform: "translateX(0%) rotateZ(0deg)"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "stripe--8a29c",
    "data-role": "first-stripe",
    fill: "transparent",
    cx: 10,
    cy: "50%",
    strokeWidth: 1.5,
    r: 0,
    opacity: 0,
    strokeDasharray: "0 0",
    strokeDashoffset: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "stripe--8a29c",
    "data-role": "second-stripe",
    fill: "transparent",
    cx: 10,
    cy: "50%",
    strokeWidth: 1.5,
    r: 7,
    opacity: 0,
    strokeDasharray: "8.79645943005142 35.18583772020568",
    strokeDashoffset: 4.39822971502571
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.631259baf9d53f8b6e56bd0e41fa3b9b.svg";
export { ForwardRef as ReactComponent };